import { type AxiosResponse } from 'axios'
import axios from '~/services/Axios-service'

export class HttpClient {
  Get<T>(url: string, query?: any): Promise<AxiosResponse<T>> {
    return axios.get<T>(url, { params: query, paramsSerializer: { indexes: null } })
  }
  Post<T>(url: string, item: any): Promise<AxiosResponse<T>> {
    return axios.post<T>(url, item)
  }
  Put<T>(url: string, item: any): Promise<AxiosResponse<T>> {
    return axios.put<T>(url, item)
  }
  Delete<T>(url: string): Promise<AxiosResponse<T>> {
    return axios.delete<T>(url)
  }
}
